import React from "react";
import { useDropzone } from "react-dropzone";
import { useEffect, useState, useCallback } from "react";
import "../MObjectStart.css";
import { parseCSV } from "../csvParser";
import {
	allDbMappings,
	crmLeadsAllDbMappings,
	crmAccountsAllDbMappings,
	crmContactsAllDbMappings,
	crmOpportunitiesAllDbMappings,
} from "../constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../toast.css";
import Alert from "@mui/material/Alert";
import { FormControl, Select, InputLabel, MenuItem } from "@mui/material";
import Upload from "../upload_purple.svg";
import CheckFilled from "../check-filled.svg";
import CsvIcon from "../b2csv.svg";
import DeleteIcon from "../delete-button.svg";

function DropZone(props) {

	//  ADDED — safely use parent-controlled values
	// (Legacy local state remains commented below as requested)
	const isActivities = props.isActivities;
	const crmType = props.crmType;

	// const getFilesFromEvent = (event) => {
	//   console.log("event coming from basic.js", event)
	//   props.setSelectedFileData({ selectedFile: event?.target?.files[0] });
	//   props.setSelectFileName(event?.target?.files[0]?.name);
	// }
	toast.configure({
		autoClose: 6000,
		draggable: true,
		hideProgressBar: false,
		position: toast.POSITION.BOTTOM_LEFT,
		icon: false,
	});

	//  Legacy local state (kept commented, NOT removed)
	// const [isActivities, setIsActivities] = useState(true);
	// const [crmType, setCrmType] = useState("leads");
	const [uploadedFile, setUploadedFile] = useState(null);
	const onDrop = useCallback(
		(acceptedFiles, fileRejections) => {
			// console.log('fileRejection', fileRejections)
			console.log("acceptedFiles", acceptedFiles);

			if (!acceptedFiles.length) {
				toast.error(<Alert severity='error'>please upload a CSV file</Alert>, {
					closeOnClick: true,
					autoClose: true,
					closeButton: true,
					newestOnTop: true,
				});
			}

			console.log("coming from basic.js ondrop", acceptedFiles);
			// props.setSelectedFileData({ selectedFile: acceptedFiles[0] });
			props.setSelectFileName(acceptedFiles[0].name);
			setUploadedFile(acceptedFiles[0]);
			// get dbMapping values from constant.js based on crmType
			const dbMappings = {
				leads: crmLeadsAllDbMappings,
				accounts: crmAccountsAllDbMappings,
				contacts: crmContactsAllDbMappings,
				opportunities: crmOpportunitiesAllDbMappings,
			};
			acceptedFiles.forEach((file) => {
				const reader = new FileReader();

				reader.onabort = () => console.log("file reading was aborted");
				reader.onerror = () => console.log("file reading has failed");

				reader.onload = () => {
					const binaryStr = reader.result;

					const { headers, rows } = parseCSV(binaryStr);

					props.setSelectedFileData({
						selectedFile: file,
						parsedData: rows,
						sampleRow: rows[0] || {},
					});

					props.setCSVHeaders(headers);
					props.setIsPicked(true);
				};

				reader.readAsText(file);
			});
		},
		[props.isActivities, props.crmType]
	);

	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
		maxFiles: 1,
		onDrop,
		accept: {
			"text/csv": [".csv"],
		},
	});

	const files = acceptedFiles.map((file) => (
		<li key={file.path}>
			{file.path} - {file.size} bytes
		</li>
	));

	const handleDownload = async () => {
		try {
			const url = isActivities
				? `${window._env_.OFFLINE_UPLOAD}/offline-data-import/get-csv-template`
				: `${window._env_.OFFLINE_UPLOAD}/offline-data-import/get-crm-csv-template/${crmType}`;

			const response = await fetch(url, {
				method: "GET",
				credentials: "include",
			});

			if (!response.ok) {
				throw new Error("Failed to download file");
			}

			const blob = await response.blob();
			const downloadUrl = window.URL.createObjectURL(blob);

			const link = document.createElement("a");
			link.href = downloadUrl;
			link.download = "sample.csv"; // You can customize filename
			document.body.appendChild(link);
			link.click();

			document.body.removeChild(link);
			window.URL.revokeObjectURL(downloadUrl);
		} catch (error) {
			console.error("Download failed:", error);
		}
	};
	useEffect(() => {
		if (props.setDownloadHandler) {
			props.setDownloadHandler(() => handleDownload);
		}
	}, [handleDownload]);

	// Legacy dropdown logic preserved (NOT removed)
	/*
	const handleDropdownChange = (event) => {
		if (event.target.value === "crm") {
			setIsActivities(false);
			props.setIsActivities(false);
		} else {
			setIsActivities(true);
			setCrmType("leads");
			props.setCrmType("leads");
			props.setIsActivities(true);
		}
	};
	const handleCRMChoice = (event) => {
		setCrmType(event.target.value);
		props.setCrmType(event.target.value);
	};

	const theDropdown = (...);
	const crmDropdown = (...);
	const crmUploadForm = (...);
	*/

	const activitiesUploadForm = (
		<section style={{ marginTop: 16 }}>
			{!uploadedFile ? (
				<div
					{...getRootProps()}
					style={{
						border: "1.5px dashed #C4B5FD",
						background: "#F5F3FF",
						borderRadius: 12,
						padding: "80px 20px",
						textAlign: "center",
						cursor: "pointer",
					}}
				>
					<input {...getInputProps()} />

					<img
						src={Upload}
						alt="upload"
						style={{
							width: 32,
							height: 32,
							marginBottom: 16,
						}}
					/>

					<div
						style={{
							fontFamily: "Inter",
							fontWeight: 500,
							fontSize: 14,
							color: "#5441D8",
							marginBottom: 8,
						}}
					>
						Drop Files or <span style={{ textDecoration: "underline" }}>Browse</span>
					</div>

					<div
						style={{
							fontFamily: "Inter",
							fontSize: 13,
							color: "#6B7280",
						}}
					>
						Make sure the file is in CSV format
					</div>
				</div>
			) : (
				<div
					style={{
						background: "#E6F4EA",
						border: "1px solid #A7D7C5",
						borderRadius: 12,
						padding: "60px 20px",
						textAlign: "center",
					}}
				>
					<img
						src={CheckFilled}
						alt="success"
						style={{
							width: 24,
							height: 24,
							marginBottom: 12,
						}}
					/>

					<div
						style={{
							fontSize: 16,
							fontWeight: 600,
							color: "#15803D",
							marginBottom: 8,
						}}
					>
						Uploaded Successfully
					</div>

					<div
						style={{
							display: "inline-flex",
							alignItems: "center",
							gap: 12,
							background: "#FFFFFF",
							borderRadius: 8,
							padding: "10px 16px",
							boxShadow: "0px 2px 6px rgba(0,0,0,0.05)",
						}}
					>
						<img
							src={CsvIcon}
							alt="csv"
							style={{
								width: 34,
								height: 35,
							}}
						/>

						<div style={{ textAlign: "left" }}>
							<div style={{ fontSize: 14, fontWeight: 500 }}>
								{uploadedFile.name}
							</div>
							<div style={{ fontSize: 12, color: "#6B7280" }}>
								{(uploadedFile.size / 1024).toFixed(1)} KB
							</div>
						</div>

						<img
							src={DeleteIcon}
							alt="delete"
							onClick={() => setUploadedFile(null)}
							style={{
								width: 26,
								height: 26,
								cursor: "pointer",
							}}
						/>
					</div>
				</div>
			)}
		</section>
	);

	return (
		<div className="uploadScreenContainer">
			{activitiesUploadForm}
		</div>
	);
}

export default DropZone;
